import React, { memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ScoutSettings from './components/scout/ScoutSettings';
import ResonanceSettings from './components/resonance/ResonanceSettings';
import SonarSettings from './components/sonar/SonarSettings';
import CommonPage from '../components/common-page/CommonPage';
import CommonTabs from '../components/common-tabs/CommonTabs';
import CommonTabPanel from '../components/common-tabs/CommonTabPanel';
import Id8Settings from './components/id8/Id8Settings';
import Activ8Settings from './components/activ8/Activ8Settings';
import MediaStudioSettings from './components/media-studio/MediaStudioSettings';
import SettingsId8NotificationBarController from './components/id8/components/notification-bar-controller/SettingsId8NotificationBarController';

import scss from './Settings.module.scss';

const Settings = () => {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const mappedRoutesToTabs = useMemo(
    () => ({
      0: 'id8',
      1: 'scout',
      2: 'resonance',
      3: 'sonar',
      4: 'activ8',
      5: 'media-studio',
    }),
    [],
  );

  const mappedTabsToRoutes = useMemo(
    () => ({
      id8: 0,
      scout: 1,
      resonance: 2,
      sonar: 3,
      activ8: 4,
      'media-studio': 5,
    }),
    [],
  );

  const TABS = [
    {
      label: 'ID8',
    },
    {
      label: 'Scout',
      disabled: true,
      tooltip: t('comingSoon'),
    },
    {
      label: 'Resonance',
      disabled: true,
      tooltip: t('comingSoon'),
    },
    {
      label: 'Sonar',
      disabled: true,
      tooltip: t('comingSoon'),
    },
    {
      label: 'ACTIV8',
    },
    {
      label: 'Media Studio',
    },
  ];

  const selectedTab = mappedTabsToRoutes[pathname.split('/')[2]] ?? 0;

  const handleChangeTab = useCallback(
    (_, newTab) => {
      navigate(`/settings/${mappedRoutesToTabs[newTab]}`);
    },
    [mappedRoutesToTabs, navigate],
  );

  return (
    <CommonPage className={scss.page}>
      <CommonTabs tabs={TABS} value={selectedTab} onChange={handleChangeTab} />

      <CommonTabPanel value={selectedTab} index={0}>
        <Id8Settings />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={1}>
        <ScoutSettings />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={2}>
        <ResonanceSettings />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={3}>
        <SonarSettings />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={4}>
        <Activ8Settings />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={5} className={scss.fullHeightPanel}>
        <MediaStudioSettings />
      </CommonTabPanel>

      <SettingsId8NotificationBarController />
    </CommonPage>
  );
};

export default memo(Settings);
